<!-- 总评center地图 -->
<style lang="stylus" scoped>
.map {
  width: 655px;
  height: 630px;
  margin: 0 auto;

  .main {
    width: 100%;
    height: 100%;
  }
}
</style>

<template>
  <div class="map">
    <img src="../../../../../static/img/secondMap/map.png" alt="">
    <!-- <div class="main"></div> -->
  </div>
</template>

<script>
import echarts from "echarts";
import axios from "axios";
import icon from "../../../../../static/img/secondMap/com.png";
export default {
  data() {
    return {
      myChart: {},
      name: this.$route.query.areaName
    };
  },
  components: {},
  mounted: function() {
    var self = this;
    console.log(this.$route.query.areaName);
    const { areaName } = this.$route.query;
    // 基于准备好的dom，初始化echarts实例
    // this.myChart = echarts.init(document.querySelector(".map .main"));
    axios.get(`static/data/百色市/${areaName}.json`).then(res => {
      const geoCoordMapList = res.data.features[0].geometry.coordinates[0][0];
      // 引入地区地图
      echarts.registerMap(areaName, res.data);
      var data;
      if (self.name === "田阳县") {
        data = [
          { name: "广西百色翠丰特色农产品有限责任公司", value: 10 },
          { name: "广西百色盛泰和农业有限公司", value: 20 },
          { name: "广西田阳新靖田农产品贸易有限公司", value: 20 },
          { name: "广西田阳古鼎香农产品综合批发市场有限公司", value: 20 },
          { name: "广西田阳穗丰园农产品贸易有限公司", value: 20 }
        ];
      } else {
        data = [
          { name: "广西百色翠丰特3色农产品有限责任公司", value: 10 },
          { name: "广西百色盛泰3和农业有限公司", value: 20 },
          { name: "广西田阳新靖3田农产品贸易有限公司", value: 20 },
          { name: "广西田阳古3鼎香农产品综合批发市场有限公司 ", value: 20 },
          { name: "广西田阳穗丰3园农产品贸易有限公司 ", value: 20 }
        ];
      }
      // 每个地区的坐标
      const geoCoordMap = {
        "广西百色翠丰特色农产品有限责任公司": [107.029082, 23.870741],
        "广西百色盛泰和农业有限公司": [106.929082, 23.670741],
        "广西田阳新靖田农产品贸易有限公司": [106.529082, 23.650741],
        "广西田阳古鼎香农产品综合批发市场有限公司": [106.875151, 23.762067],
        "广西田阳穗丰园农产品贸易有限公司": [106.533201, 23.555777]
      };

      // 每个地区的设备数量值

      const convertData = function(data) {
        const res = [];
        for (let i = 0; i < data.length; i++) {
          const geoCoord = geoCoordMap[data[i].name];
          if (geoCoord) {
            res.push({
              name: data[i].name,
              value: geoCoord.concat(data[i].value)
            });
          }
        }
        return res;
      };

      function tooltipCharts() {
        const tooltipDom = document.getElementById("tooltipPieId");
        if (tooltipDom) {
          const tooltipCharts = echarts.init(
            document.getElementById("tooltipPieId")
          );
          const data = [
            { name: "百色芒果", value: 675 },
            { name: "圣女果", value: 1397 },
            { name: "牛心李", value: 318 },
            { name: "西林火姜", value: 101 },
            { name: "其他", value: 110 }
          ];
          let total = 0;
          for (var i = 0; i < data.length; i++) {
            total += data[i].value;
          }
          const tooltopOpiton = {
            color: [
              "#CC68FA",
              "#FF6438",
              "#35CDFD",
              "#FF7B7B",
              "#FFFE75",
              "#22FAA1"
            ],
            title: {
              text: "总数",
              subtext: total,
              textStyle: {
                fontSize: 12,
                color: "#fff",
                align: "center"
              },
              subtextStyle: {
                fontSize: 12,
                color: "#fff"
              },
              x: "22%",
              y: "33%"
            },
            grid: {
              bottom: 150,
              left: 100,
              right: "10%"
            },
            legend: {
              right: "right",
              top: "-4%",
              textStyle: {
                color: "#f2f2f2",
                fontSize: 12
              },
              icon: "pin",
              data,
              formatter: function(name) {
                for (let i = 0; i < data.length; i++) {
                  if (name === data[i].name) {
                    return `${name} ${(data[i].value / total).toFixed(2) *
                      100}% ${data[i].value}`;
                  }
                }
              }
            },
            series: [
              {
                radius: ["40%", "70%"],
                center: ["30%", "50%"],
                type: "pie",
                label: {
                  normal: {
                    show: false
                  },
                  emphasis: {
                    show: true
                  }
                },
                labelLine: {
                  normal: {
                    show: false
                  }
                },
                name: "信息统计",
                data
              }
            ]
          };
          tooltipCharts.setOption(tooltopOpiton);
        }
      }

      const option = {
        // 自定义引导饼图
        tooltip: {
          show: true,
          trigger: "item",
          triggerOn: "mousemove",
          enterable: true,
          transitionDuration: 1
        },
        geo: {
          map: areaName,
          show: true,
          label: {
            emphasis: {
              show: false
            }
          },
          itemStyle: {
            normal: {
              areaColor: "#7868EC",
              borderColor: "#BCC5EA",
              borderWidth: 2,
              shadowColor: "#5AB2FE",
              shadowBlur: 5
            }
          },
          zoom: 1.2
        },
        series: [
          {
            type: "map",
            map: areaName,
            backgroundColor: "#2a70da",
            geoIndex: 1,
            aspectScale: 0.75,
            zoom: 1.2,
            markPoint: {
              symbol: "image://https://s2.ax1x.com/2019/05/20/Extm4S.png",
              symbolSize: 400
            },
            label: {
              normal: {
                show: true,
                textStyle: {
                  color: "#fff",
                  fontSize: 20
                }
              },
              emphasis: {
                textStyle: {
                  color: "#fff",
                  fontSize: 20
                }
              }
            },
            roam: false,
            itemStyle: {
              normal: {
                areaColor: "#2a70da",
                borderColor: "#52ffff",
                borderWidth: 2
              },
              emphasis: {
                areaColor: "#328DDF",
                borderColor: "#BCC5EA",
                shadowBlur: 8
              }
            },
            data
          },
          {
            name: "企业图片",
            type: "scatter",
            markPoint: {
              symbol: "pin"
            },
            coordinateSystem: "geo",
            symbol: "image://" + icon,
            symbolSize: 40,
            markPoint: {
              symbol: "pin"
            },
            label: {
              normal: {
                show: true,
                position: "top",
                formatter: "{b|{b}}",
                rich: {
                  b: {
                    fontFamily: "sans-serif",
                    height: 30,
                    padding: [0, 10],
                    fontSize: 14,
                    align: "center",
                    backgroundColor: "#1375C9",
                    borderColor: "rgba(0,0,0,1)",
                    borderRadius: 10,
                    textShadowColor: "transparent",
                    color: "#fff",
                    textBorderWidth: 0,
                    textShadowColor: "transparent",
                    textShadowBlur: 0,
                    textShadowOffsetX: 0,
                    textShadowOffsetY: 0
                  }
                }
              }
            },
            zlevel: 6,
            data: convertData(data)
          }
        ]
      };
      this.myChart.setOption(option);
      let index = 0;
      setInterval(() => {
        this.myChart.dispatchAction({
          type: "showTip",
          seriesIndex: 0,
          dataIndex: index
        });
        index++;
        if (index >= data.length) {
          index = 0;
        }
      }, 3000);
    });
  },
  methods: {}
};
</script>



// WEBPACK FOOTER //
// index.vue?7c545737